import { func, shape, string, bool } from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { SOCIAL_LINKS } from 'constants/links';
import { subscribeUserToList } from 'components/EmailListDataProvider/helpers';
import EmailSignupForm from 'oxygen-lib-ui/components/EmailSignupForm';
import EmailSignupLoadingMessage from 'oxygen-lib-ui/components/EmailSignupLoadingMessage';

/**
 * displays a loading message, the signup form, or a list closed message based
 * on the provided props. this component has no internal state; expects to be
 * wrapped with an EmailListDataProvider component that provide requisite props.
 *
 */
function EmailSignup(props) {
  const {
    description,
    hasFocus,
    isActive,
    isLoading,
    label,
    listDataError,
    listKey,
    sponsor,
    optInEvent,
    title,
    variant,
    onSubscribe,
    confirmationMessage
  } = props;

  const filteredSocialLinks = SOCIAL_LINKS.filter(
    link => link.label !== 'email'
  );
  const showLoadingMessage = isLoading || listDataError;

  const wrapperClasses = classnames('EmailSignup', `EmailSignup--${listKey}`, {
    [`EmailSignup--${variant}`]: variant,
    'EmailSignup--loading': isLoading,
    'EmailSignup--closed-list': !isActive
  });

  return (
    <div className={wrapperClasses}>
      {showLoadingMessage && (
        <EmailSignupLoadingMessage error={listDataError} />
      )}

      {!showLoadingMessage && isActive && (
        <EmailSignupForm
          title={title}
          description={description}
          label={label || 'email address'}
          listKey={listKey}
          optInEvent={optInEvent}
          subscribeUserToList={subscribeUserToList}
          socialLinks={filteredSocialLinks}
          sponsor={sponsor}
          hasFocus={hasFocus}
          onSubscribe={onSubscribe}
          customConfirmationHtml={
            confirmationMessage ? (
              <div>
                <h4 className="EmailSignupConfirmation__headline">
                  Thank You!
                </h4>
                <p className="EmailSignupConfirmation__body">
                  {confirmationMessage}
                </p>
              </div>
            ) : (
              undefined
            )
          }
        />
      )}

      {!showLoadingMessage && !isActive && (
        <div className="EmailSignup__no-list">
          <h4>Sorry, this list is no longer accepting subscriptions.</h4>
          {/* prettier-ignore */}
          <p>Feel free to <a href="/email">subscribe to our other emails</a>.</p>
        </div>
      )}
    </div>
  );
}

EmailSignup.propTypes = {
  description: string,
  hasFocus: bool,
  isActive: bool,
  isLoading: bool,
  label: string,
  listDataError: shape({ msg: string }),
  listKey: string.isRequired,
  sponsor: EmailSignupForm.propTypes.sponsor,
  optInEvent: string,
  title: string,
  variant: string,
  onSubscribe: func,
  confirmationMessage: string
};

EmailSignup.defaultProps = {
  description: undefined,
  hasFocus: false,
  isActive: false,
  isLoading: false,
  label: undefined,
  listDataError: undefined,
  optInEvent: '',
  sponsor: {},
  title: undefined,
  variant: undefined,
  onSubscribe: undefined,
  confirmationMessage: ''
};

export default EmailSignup;
